import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: ${({ theme }) =>
    theme.isMobile ? `calc(100dvh - 6.4rem)` : '100dvh'};
  width: 100%;
  padding-right: ${({ theme }) => theme.spacing(0.5)};

  overflow: auto;
`;

export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};

  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(1.5)} ${theme.spacing(2)} ${theme.spacing(2)}`};
  min-width: 0;
`;

export const ScrollContainer = styled.div`
  padding: ${({ theme }) => `${theme.spacing(3)} 0`};

  height: 100%;
  overflow: auto;
`;

export const GoalScrollContainer = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing(6)} ${theme.spacing(1)} ${theme.spacing(6)} ${theme.spacing(4)}`};
  height: 100%;
  overflow: auto;

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding: ${({ theme }) => `${theme.spacing(3)} 0`};
    `};
`;
